.tab-list {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;
  flex: 1;
}
